import React from "react";
import PropTypes from "prop-types";
import "./NavLogs.scss";
import { navLogShape, resolutionPropType } from "app/utils/propTypes";
import { FormattedMessage } from "react-intl";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import NavLogProduct from "app/pages/Listing/NavLogs/NavLogProduct";
import Separator from "app/pages/.shared/Separator";
import { sendTagOnNavlogPrevious, sendTagOnNavlogNext } from "app/utils/analytics";
import { NAVLOGS_SHOW_SLIDES_NUMBER } from "app/constants";
const PLACEHOLDER_ID = "navlog-placeholder";
import Swiper from "react-id-swiper";
import get from "lodash/get";
class NavLogs extends React.Component {
	constructor(props) {
		super(props);
		this.state = { swiper: null, isEnd: false, isBeginning: true };
		this.updateSwiper = this.updateSwiper.bind(this);
		this.slidePrev = this.slidePrev.bind(this);
		this.slideNext = this.slideNext.bind(this);
		this.slideNextTransitionEnd = this.slideNextTransitionEnd.bind(this);
		this.slidePrevTransitionEnd = this.slidePrevTransitionEnd.bind(this);
	}

	updateSwiper(swiper) {
		this.setState({ swiper: swiper });
	}

	slidePrev() {
		this.state.swiper.slidePrev();
	}
	slideNext() {
		this.state.swiper.slideNext();
	}

	slideNextTransitionEnd() {
		const { navLogs, resolution } = this.props;
		const navigateToSlideIndex = Math.round(
			NAVLOGS_SHOW_SLIDES_NUMBER[resolution] + this.state.swiper.activeIndex - 1
		);

		sendTagOnNavlogNext({
			...navLogs[navigateToSlideIndex],
			lastSeenProductType: navLogs[navigateToSlideIndex].quotationURL ? "quote" : "product",
		});
	}

	slidePrevTransitionEnd() {
		sendTagOnNavlogPrevious();
	}

	render() {
		const { navLogs = [], resolution } = this.props;

		const isDesktop =
			resolution === RESOLUTION.LARGE ||
			resolution === RESOLUTION.XLARGE ||
			resolution === RESOLUTION.MEDIUM;

		const showArrows = isDesktop && navLogs.length > 3;

		const swiperParams = {
			shouldSwiperUpdate: true,
			slideChangeTransitionEnd: this.transitionEnd,
			getSwiper: this.updateSwiper,
			slidesPerView: NAVLOGS_SHOW_SLIDES_NUMBER[resolution],
			spaceBetween: 10,
			centeredSlides: !isDesktop && navLogs.length === 1,
			on: {
				transitionEnd: () => {
					this.setState(state => {
						const isBeginning = get(state, "swiper.isBeginning");
						const isEnd = get(state, "swiper.isEnd");

						return {
							isBeginning: isBeginning,
							isEnd: isEnd,
						};
					});
				},
				slideNextTransitionEnd: this.slideNextTransitionEnd,
				slidePrevTransitionEnd: this.slidePrevTransitionEnd,
			},
		};

		// si on affiche moins de 3 produits, alors on complete avec des placeholders jusqu'à 3
		if (isDesktop) {
			if (navLogs.length === 1) {
				navLogs.push({ uri: PLACEHOLDER_ID, id: `${PLACEHOLDER_ID}-1` });
				navLogs.push({ uri: PLACEHOLDER_ID, id: `${PLACEHOLDER_ID}-2` });
			} else if (navLogs.length === 2) {
				navLogs.push({ uri: PLACEHOLDER_ID, id: `${PLACEHOLDER_ID}-1` });
			}
		}

		return (
			navLogs.length >= 1 && (
				<div className="navlogs">
					<h1 className="navlogs__title">
						<FormattedMessage id="listing.last.viewed.trip" />
					</h1>

					<div className="navlogs__carousel">
						<Swiper {...swiperParams}>
							{navLogs.map(navLog => {
								if (navLog.uri === PLACEHOLDER_ID) {
									return <div key={navLog.id} className="navlogs__placeholder" />;
								}

								return (
									<div key={navLog.id}>
										<NavLogProduct {...navLog} resolution={resolution} />
									</div>
								);
							})}
						</Swiper>
						<div className="navlogs__carousel__button navlogs__carousel__button--next">
							{showArrows && !this.state.isEnd && this.state.swiper && (
								<i
									className="icon icon-navigation icon--next"
									onClick={this.slideNext}
								/>
							)}
						</div>
						<div className="navlogs__carousel__button navlogs__carousel__button--previous">
							{showArrows && !this.state.isBeginning && this.state.swiper && (
								<i
									className="icon icon-navigation icon--previous"
									onClick={this.slidePrev}
								/>
							)}
						</div>
					</div>
					<Separator design="middle" />
				</div>
			)
		);
	}
}

NavLogs.propTypes = {
	navLogs: PropTypes.arrayOf(navLogShape),
	resolution: resolutionPropType,
};

export default NavLogs;
